import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { fadeIn } from 'src/app/shared/constants/animations';
import { Table } from 'src/app/shared/helpers/table.helpers';
import { AccountUpdateMainModalComponent } from '../../../account-request-workflows/modals/account-update-main-modal/account-update-main-modal.component';
import { Account } from '../../models/account.models';
import { AccountTableHeaders } from '../../models/accountTable.model';
import { Permission } from 'src/app/core/clients/generated/client';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { virtualScrolloffsetTranslate } from 'src/app/shared/helpers/virtual-scroll-offset-translate.helper';
import { OpenSsoAgentSelectModalComponent } from 'src/app/shared/modals/sso-agent-select-modal/sso-agent-select-modal.component';
import { Router } from '@angular/router';

@Component({
  animations: [fadeIn],
  selector: 'app-accounts',
  templateUrl: './accounts-list.component.html',
})

export class AccountsListComponent implements OnChanges {
  constructor(
    private dialog: MatDialog,
    private router: Router,
  ) { }

  @ViewChild(CdkVirtualScrollViewport, { static: false }) public viewPort?: CdkVirtualScrollViewport;
  @Input() accounts: Account[] = [];
  isLoading = true;
  table: Table<Account> = new Table<Account>(AccountTableHeaders, 1, 'asc');
  perm = Permission;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['accounts']?.isFirstChange()) {
      this.table.setBody(this.accounts);
      this.isLoading = false;
    }
  }

  // This get the offset amount of the entire virtual scroll viewport from the top in pixel.
  // We use this to manually sticky the header back to the top position in the HTML since virtual scroll messes with sticky headers
  public get offsetTranslate(): string {
    return virtualScrolloffsetTranslate(this.viewPort);
  }

  openAccountUpdateModal(account: Account): void {
    this.dialog.open<AccountUpdateMainModalComponent>(AccountUpdateMainModalComponent, {
      height: '72rem',
      minHeight: '50rem',
      data: account.InvestmentAccountId ? account : null
    });
  }

  openOrionAgentSelectModal(destination: string | null): void {
    this.dialog.open(OpenSsoAgentSelectModalComponent, {
      minHeight: '28rem',
      autoFocus: false,
      data: { BaseUrl: 'api/sso/orion/portal/' + destination + '?appearAsCrmAgentId=' }
    });
  }

  navigateToInvestmentAccount(account: Account): void {
    if (account.IsInvestmentAccount && account.CustodianId === 2 && account.Value && account.Value > 0) {
      this.router.navigateByUrl('portal/account-detail/' + account.InvestmentAccountId);
    } else return;
  }
}